import * as React from 'react';
import { StatefulPopover, PLACEMENT } from 'baseui/popover';
import { useDispatch } from 'react-redux'
import { Menu } from 'baseui/menu';
import { Button, KIND } from 'baseui/button';
import accountIcon from '../../../../../../assets/img/account-box.svg';
import logoutIcon from '../../../../../../assets/img/logout-exit.svg';
import AuthActions from '../../../../../../../actions/Auth';

const LogOutButton = React.memo(() => {
    const dispatch = useDispatch();
    const onLogout = () => {
        dispatch(AuthActions.logOut)
    }
    return (
        <div onClick={onLogout} className='turing-mobile-home-header__menu'>
            <img src={logoutIcon} alt="L" />
            <span className='turing-mobile-home-header__menu-text'>Logout</span> 
        </div> 
    )
})

const UserDropdown = React.memo(() => {
    return (
        <StatefulPopover
            placement={PLACEMENT.bottomRight}
            content={() => (
                <Menu
                    items={[{ label: <LogOutButton /> }]}
                />
            )}
        >
        <Button kind={KIND.tertiary}>
            <img src={accountIcon} alt="Menu" />
        </Button>
        </StatefulPopover>
    );
})

export default UserDropdown;
